import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { createSpeaker } from "api/speaker.api";
import SpeakerForm from "components/speaker/SpeakerForm";
import Toast from "components/Toast";

export default function CreateSpeaker() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  const handleSubmit = async (fd) => {
    try {
      await createSpeaker(fd);
      setToast({
        open: true,
        title: "Success",
        message: "Speaker created successfully",
        type: "success",
      });
     
    } catch (err) {
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Toast
        open={toast.open}
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
           navigate("/admin/speakers");
        }}
      />
      <SpeakerForm
        onSubmit={handleSubmit}
        onBack={() => navigate("/admin/speakers")}
        alert={alert}
        setAlert={setAlert}
      />
    </>
  );
}